import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion } from "framer-motion";
import CultureImg from "../media/Culture.avif";
import PeoplePowered from "../media/PeoplePowered.avif";
import BoldIdeas from "../media/BoldIdeas.avif";
import EthicallyInspired from "../media/EthicallyInspirational.avif";
import Fashion from "../media/Fashion.jpg";
import CelebratingIdeas from "../media/CelebratingIdeas.avif";

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

const Culture = () => {
  return (
    <>
      <Header />
      <div className="w-full">
        {/* Hero Section */}
        <motion.section
          className="relative mt-16 md:mt-24 h-[70vh] bg-cover bg-center"
          style={{ backgroundImage: `url(${CultureImg})` }}
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
            <h1 className="text-white font-serif text-3xl md:text-5xl font-bold text-center">
              Driven individuals inspiring meaningful change
            </h1>
          </div>
        </motion.section>

        {/* Intro Section */}
        <motion.section
          className="max-w-7xl mx-auto px-6 py-16 text-center"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl font-serif md:text-4xl mb-6 text-slate-600">
            We are a dynamically creative company driven by our diverse and talented team. Their passion and dedication to their work are the core elements that run through every aspect of our operation.
          </h2>
        </motion.section>

        {/* Content Blocks */}
        <section className="max-w-6xl mx-auto px-6 space-y-24">
          <motion.div
              className={"grid md:grid-cols-2 gap-10 items-center"}
              initial="hidden"
              whileInView="visible"
              variants={fadeInUp}
              viewport={{ once: true }}
            >
              <img src={PeoplePowered} alt="people-powered" className="rounded-2xl shadow-lg md:order-2" />
              <div className="md:order-1">
                <h2 className="text-6xl font-bold text-brand mb-4">01</h2>
                <h4 className="text-3xl font-semibold mb-3 text-black">People-Powered</h4>
                <p className="text-gray-700 leading-relaxed">The team behind our business is the foundation of everything we do. From designing the latest trends using cutting-edge technology to collaborating with top global suppliers, our people are at the heart of it all.</p>
              </div>
            </motion.div>
            <motion.div
              className={"grid md:grid-cols-2 gap-10 items-center"}
              initial="hidden"
              whileInView="visible"
              variants={fadeInUp}
              viewport={{ once: true }}
            >
              <img src={BoldIdeas} alt="bold-ideas" className="rounded-2xl shadow-lg md:order-1" />
              <div className="md:order-2">
                <h2 className="text-6xl font-bold text-brand mb-4">02</h2>
                <h4 className="text-3xl font-semibold mb-3 text-black">Bold Ideas, Visionary Thinking, Bright Future</h4>
                <p className="text-gray-700 leading-relaxed">Our innovative and forward-thinking approach sets us apart, as we fully embrace experimentation and groundbreaking strategies to provide our customers with exceptional service.</p>
              </div>
            </motion.div>
            <motion.div
              className={"grid md:grid-cols-2 gap-10 items-center"}
              initial="hidden"
              whileInView="visible"
              variants={fadeInUp}
              viewport={{ once: true }}
            >
              <img src={EthicallyInspired} alt="ethically-inspired" className="rounded-2xl shadow-lg md:order-2" />
              <div className="md:order-1">
                <h2 className="text-6xl font-bold text-brand mb-4">03</h2>
                <h4 className="text-3xl font-semibold mb-3 text-black">Ethically Inspired</h4>
                <p className="text-gray-700 leading-relaxed">Ethical practices are not just a trend for us—they are the foundation of everything we do. From our global suppliers and sourcing methods to our sustainable printing policies in the office, we ensure that our business is one that everyone here can take pride in.</p>
              </div>
            </motion.div>
            <motion.div
              className={"grid md:grid-cols-2 gap-10 items-center"}
              initial="hidden"
              whileInView="visible"
              variants={fadeInUp}
              viewport={{ once: true }}
            >
              <img src={Fashion} alt="fashion" className="rounded-2xl shadow-lg md:order-1" />
              <div className="md:order-2">
                <h2 className="text-6xl font-bold text-brand mb-4">04</h2>
                <h4 className="text-3xl font-semibold mb-3 text-black">Fashion is an Adventure</h4>
                <p className="text-gray-700 leading-relaxed">Fashion isn’t just a job; it’s a way of life. From the designs we craft to the suppliers we collaborate with, our approach is driven by passion, dedication, and above all, a love for what we do. Enjoyment is at the heart of every step we take.</p>
              </div>
            </motion.div>
        </section>

        {/* Closing Section */}
        <motion.section
          className="relative h-[60vh] mt-20 bg-cover bg-center"
          style={{ backgroundImage: `url(${CelebratingIdeas})` }}
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col items-center justify-center">
            <h2 className="font-serif text-white text-3xl md:text-5xl font-bold text-center max-w-6xl">
              Celebrating Talent, Recognizing Achievement
            </h2>
            <h2 className="text-white text-sm md:text-lg font-normal text-center max-w-5xl mt-6 px-4">
              At Yking, we value the incredible talent within our team and ensure it gets the recognition it deserves. From team-building away days to summer celebrations and awards ceremonies, we go the extra mile to reward and honor our staff for their dedication and hard work. 
            </h2>
            <a href="/our-philosophy">
              <button className="border text-white mt-4 shadow-lg px-4 py-2">
                Our Philosophy
              </button>
            </a>
          </div>
        </motion.section>
      </div>
      <Footer />
    </>
  );
};

export default Culture;
